<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>Marketing Calendars</h2>
        <a href="#" class="btn btn-primary"
          style="position: absolute;right: 0;top: 0;"
          @click="openCreateModal"
        >
          <i class="fa fa-plus"></i> Create
        </a>
      </div>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center"
          v-for="marketingCalendar in marketingCalendars"
        >
          {{ marketingCalendar.name }}
          <div>
            <a :href="`/marketing_calendars/${marketingCalendar.id}`" class="btn btn-sm btn-primary">
              <i class="fa fa-list-alt"></i>
            </a>
            <button type="button" class="btn btn-warning btn-sm"
              @click="openEditModal(marketingCalendar)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn btn-secondary btn-sm"
              @click="deleteProduct(marketingCalendar)"
            >
              <i class="fa fa-trash-alt"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <cu-modal :modalContent="modalContent" v-if="modalContent"
      @stored="stored"
      @updated="updated"
    />
  </div>
</template>

<script>
  import CuModal from './CuModal'

  export default {
    props: ['initMarketingCalendars'],
    components: { CuModal },
    data() {
      return {
        marketingCalendars: this.initMarketingCalendars,
        modalContent: null,
      }
    },
    methods: {
      openCreateModal() {
        this.modalContent = {
          title: `Create Marketing Calendar`,
          formClassFields: {
            name: '',
          },
          submitMethod: 'post',
          submitUrl: `/marketing_calendars`,
          successEvent: 'stored',
          submitText: 'Create',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      stored(marketingCalendar) {
        window.notification.success(`${marketingCalendar.name} has been created`, 'Success!')
        this.marketingCalendars.push(marketingCalendar)
        $('#cuModal').modal('hide')
      },
      openEditModal(marketingCalendar) {
        this.modalContent = {
          title: `Edit ${marketingCalendar.name}`,
          formClassFields: marketingCalendar,
          submitMethod: 'put',
          submitUrl: `/marketing_calendars/${marketingCalendar.id}`,
          successEvent: 'updated',
          submitText: 'Save',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      updated(marketingCalendar) {
        window.notification.success(`${marketingCalendar.name} has been updated`, 'Success!')
        const index = this.marketingCalendars.findIndex(({id}) => marketingCalendar.id === id)
        this.marketingCalendars.splice(index, 1, marketingCalendar)
        $('#cuModal').modal('hide')
      },
      deleteProduct(marketingCalendar) {
        if (window.confirm(`Do you really want to delete the Marketing Calendar ${marketingCalendar.name}?`)) {
          window.axios.delete(`/marketing_calendars/${marketingCalendar.id}`).then(({data}) => {
            window.notification.success(`${data.name} has been deleted`, 'Success!')
            const index = this.marketingCalendars.findIndex(({id}) => marketingCalendar.id === id)
            this.marketingCalendars.splice(index, 1)
          })
        }
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#cuModal', () => this.modalContent = null)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/marketing_calendars/MarketingCalendarIndex.vue